import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { PRODUCT_MOCKUP, PRODUCT_MOCKUP_ALT, heroGuarantees } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-16 pt-5 sm:pb-20 sm:pt-8" data-id="element-137" data-mp="9l357ep60g51">
      <div className="mx-auto max-w-4xl text-center" data-id="element-138" data-mp="4n1lqsntuet1">
        <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.18em] text-brand sm:mb-4" data-id="element-139" data-mp="129h0vnss70df">
          Das komplette Mathematik-Curriculum
        </p>
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} lang="de" className="hyphens-auto break-words font-display text-[1.85rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl md:text-[3.4rem]" data-id="element-140" data-mp="xaxgvsxqzynp">
          Unterrichte ein ganzes Jahr Mathematik in nur{' '}
          <span className="italic text-brand" data-id="element-141" data-mp="380vznzu8sxe7">5 Minuten Vorbereitung</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: EASE
      }} className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-ink/60 sm:mt-5 sm:text-lg" data-id="element-142" data-mp="3j925dog4jqvj">
          MATHE BEREIT™ ist ein komplettes, fertiges Mathematik-Curriculum — 6 Bände voller sofort
          einsetzbarer Unterrichtsmaterialien, visueller Erklärungen, Übungen und
          Schritt-für-Schritt-Lösungen. Einfach öffnen, auswählen und loslegen.
        </motion.p>

        <motion.figure initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: EASE
      }} className="mx-auto mt-4 max-w-2xl sm:mt-10 sm:pb-5" data-id="element-143" data-mp="2qkdcudt4wtve">
          <img src={PRODUCT_MOCKUP} alt={PRODUCT_MOCKUP_ALT} className="mx-auto w-[64%] max-h-[38vh] max-w-lg object-contain drop-shadow-[0_18px_24px_rgba(20,17,15,0.25)] sm:max-h-none sm:w-[78%]" data-id="element-144" data-mp="2hjyn92950sm3" />
          <figcaption className="mx-auto mt-4 hidden max-w-md text-xs leading-relaxed text-ink/50 sm:block" data-id="element-145" data-mp="nat8heoiaqma">
            {PRODUCT_MOCKUP_ALT}
          </figcaption>
        </motion.figure>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: EASE
      }} className="mt-3 sm:mt-6" data-id="element-146" data-mp="ddf2ya44fm8r">
          <CtaButton href="#offer" className="w-full sm:w-auto" data-id="element-147" data-mp="161aul0eu2nyo" />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-148" data-mp="15zzvhdwc24dw">
            {heroGuarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-149" data-mp="x37b09nes19i" data-mpi={index}>
                <span data-id="element-150" data-mp="3ltqbtahzursg">{item}</span>
                {index < heroGuarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-151" data-mp="3hqalsx0fjpoq">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}